import { Routes } from "const";
import React from "react";
import { Redirect } from "react-router-dom";

const RedirectFallbackErrorPage = ({ to }) => {
  return <Redirect to={to} />;
};

RedirectFallbackErrorPage.defaultProps = {
  to: Routes.Error,
};

export default RedirectFallbackErrorPage;
